import * as tslib_1 from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
let ProgressBar = class ProgressBar extends Vue {
};
tslib_1.__decorate([
    Prop()
], ProgressBar.prototype, "total", void 0);
tslib_1.__decorate([
    Prop()
], ProgressBar.prototype, "current", void 0);
ProgressBar = tslib_1.__decorate([
    Component({
        components: {},
    })
], ProgressBar);
export default ProgressBar;
